<template>
  <div class="content">
    <div class="content-left">
      <div class="content-left-top">
        <span class="title">组织机构</span>
        <!-- <span class="button" @click="addOrganize">创建</span> -->
      </div>

      <div class="tree">
        <el-tree ref="tree" :data="treeData" :props="defaultProps" node-key="id" @node-click="handleNodeClick" 
        highlight-current :default-expanded-keys="defaultExpandedKeys"></el-tree>
      </div>
    </div>

    <div class="content-right">
      <div class="content-right-box1">
        <div class="content-right-top">
          <span class="title">{{partyBranchName}}</span>
        </div>

        <div class="box1-bottom">
          <div class="box1-main">
            <div class="p-1">
              <p style="font-size: 16px; color: #666;">书记：{{partyBranchInfo.name || ''}}</p>
              <p>
                <span class="button" @click="handleEdit">编辑</span>
                <span class="button" @click="handleDelete(partyBranchInfo)" style="border: 1px solid #FFA6A6;color: #FFA6A6;margin-left: 8px;">删除</span>
              </p>
            </div>
            <p style="font-size: 16px; color: #666;margin: 16px 0;">成立日期：{{partyBranchInfo.establishDate || ''}}</p>
            <p style="font-size: 16px; color: #666;">党员人数：{{partyBranchInfo.memberCount || ''}}</p>
          </div>
        </div>
      </div>

      <div class="content-right-box2">
        <div class="content-right-top">
          <span class="title">党员名册</span>
          <div>
            <el-input v-model="name" size="small" clearable prefix-icon="el-icon-search" placeholder="请输入姓名"></el-input>
            <span class="button-2" @click="select" style="margin: 0 8px 0 10px;">查询</span>
            <!-- <span class="button-2">添加</span> -->
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" stripe height="100%">
            <el-table-column label="序号" width="60" prop="index"></el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <span>{{scope.row.user.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="身份证号">
              <template slot-scope="scope">
                <span>{{scope.row.user.idcard}}</span>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <span>{{scope.row.user.username}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <span class="button" @click="handleDelete(scope.row)" style="border: 1px solid #FFA6A6;color: #FFA6A6;">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
       
      </div>

    </div>

    <el-dialog
      class="dialog"
      title="编辑"
      :visible.sync="dialog"
      width="500px"
      center
      :close-on-click-modal="false"
      >

      <el-form :model="form" label-width="120px" label-position="right">
        <el-form-item label="书记：">
          <el-select v-model="form.userId" size="small"> 
            <el-option v-for="item in person" :key="item.id" :label="item.name" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成立时间：">
          <el-date-picker
            v-model="form.establishDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        addOrganizeDialog: false,     // 创建组织弹出框
        treeData: [],
        defaultProps: {
          children: 'treeList',
          label: 'name'
        },
        defaultExpandedKeys: [],   // 默认展开

        form: {       
          userId: '',
          establishDate: '',
          secretaryFlag: 1,
          officeId: '',
          partyBranchId: ''
        },

        pageSize: 20,
        pageNum: 1,
        total: 0,

        dialog: false,
        partyBranchId: '',    // 一级tree id
        partyBranchName: '',   //  党支部名称
        partyBranchInfo: {},   //  党支部信息  

        person: [],   // 正式党员
        name: '',    // 查询条件
        tableData: []



      }
    },

    created() {
      this.projectId = util.session.get('groupId')
      this.getTree()
    },

    methods: {
       handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },

      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },

      select() {
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },

      getTree(){
        myHttp.findProjectOfficeTreeList({
            projectId: this.projectId,
            name: ''
        }).then(resp => {
          if (resp.data.code === 200) {
            const list = resp.data.data.officeTreeList || []
            const data = util.common.listToTree('id','parentId',list)
            console.log(data);
            this.treeData = data
            if(data.length != 0) {
              this.partyBranchId = data[0].id
              this.partyBranchName = data[0].name
              this.form.partyBranchId = data[0].id
              this.form.officeId = data[0].treeList[0].id
            }
            this.getPartyBranch()
            this.getData()
            this.defaultExpandedKeys.push(data[0].id)
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(data[0].treeList[0].id)
            })
          }
        })
      },

      handleNodeClick(data, node) {
        console.log(data);
        console.log(node);
        if(node.level == 1) {
          this.form.partyBranchId = data.id
          this.partyBranchId = data.id
        }else {
          this.form.partyBranchId = data.parentIds.split(',')[1]
          this.partyBranchId = data.parentIds.split(',')[1]
        }
        this.form.officeId = data.id
        for(let i=0; i<this.treeData.length;i++) {
          if(this.partyBranchId == this.treeData[i].id) {
            this.partyBranchName = this.treeData[i].name
            break
          }
        }
        this.getPartyBranch()
        this.getData(node.level)
      },

      // 获取党支部
      getPartyBranch() {
        myHttp.getPartySecretary({
          groupId: this.projectId,
          partyBranchId: this.partyBranchId
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            let obj = {name: '', establishDate: '', memberCount: ''}
            this.partyBranchInfo = res.data.data || obj
          }
        })
      },

      // 获取正式党员
      getReallyPerson() {
        myHttp.getAllPartyMember({
          partyBranchId: this.partyBranchId,
          groupId: this.projectId
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.person = res.data.data
          }
        })
      },

      // 获取人员
      getData(level) {
        // 如果点击的是一级的话， 传 partyBranchId 参数    否则  传 officeId 参数
        if(level == 1) {
          myHttp.getPartyMember({
            groupId: this.projectId,
            partyBranchId: this.partyBranchId,
            name: this.name,
            process: '4,5',
            pageSize: this.pageSize,
            pageNum: this.pageNum
          }).then(res => {
            console.log(res);
            if(res.data.code === 200) {
              const list = res.data.data.pageInfo.list
              list.forEach((item, index) => {
                item.index = (this.pageNum - 1) * this.pageSize + 1 + index
              })
              this.tableData = list
              this.total = res.data.data.pageInfo.total
            }
          })
        }else {
           myHttp.getPartyMember({
            groupId: this.projectId,
            officeId: this.form.officeId,
            name: this.name,
            process: '4,5',
            pageSize: this.pageSize,
            pageNum: this.pageNum
          }).then(res => {
            console.log(res);
            if(res.data.code === 200) {
              const list = res.data.data.pageInfo.list
              list.forEach((item, index) => {
                item.index = (this.pageNum - 1) * this.pageSize + 1 + index
              })
              this.tableData = list
              this.total = res.data.data.pageInfo.total
            }
          })
        }
      },

      // 编辑
      handleEdit() {
        this.getReallyPerson()
        this.form.establishDate = this.partyBranchInfo.establishDate
        this.form.userId = this.partyBranchInfo.userId
        this.dialog = true
      },

      // 打卡创建组织弹出框
      addOrganize() {
        this.organizeTitle = '创建组织'
        this.addOrganizeDialog = true
      },

      // 编辑 提交 党支部
      submitForm() {
        this.form.groupId = this.projectId
        this.form.createBy = util.session.get('user').id
        myHttp.createInfoPartyManage(this.form).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.$message.success('操作成功！！')
            this.dialog = false
            this.form.userId = ''
            this.form.establishDate = ''
            this.getPartyBranch()
          }else {
            this.$message.error(res.data.msg)
          }
        })
      },

      // 删除
      handleDelete(row, index) {
        console.log(row);
        this.$confirm('此操作将删除该人员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteByIdParty({
            id: row.id
          }).then(res => {
            if(res.data.code === 200) {
              this.$message.success('删除成功！！')
              this.getPartyBranch()
              this.getData()
            }else {
              this.$message.error(res.data.msg)
            }
          })
        }).catch(() => {
               
        });
      },
    },
  }
</script>

<style scoped>
.content {
  flex-direction: row;
}

.content-left {
  width: 13.3333vw;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 16px;
}

.content-left-top, .content-right-top {
  display: flex;
  height: 48px;
  border-bottom: 1px solid #E4E7EE;
  padding: 11px 16px;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 16px;
  color: #666;
}

.button {
  display: inline-block;
  width: 46px;
  height: 26px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #D4D6D9;
  cursor: pointer;
  font-size: 14px;
  color: #31373D;
  text-align: center;
  line-height: 26px;
}

.button-2 {
  display: inline-block;
  width: 52px;
  height: 32px;
  border-radius: 4px;
  box-sizing: border-box;
  background: #3871E5;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}

.tree {
  padding: 8px 16px;
  height: calc(100% - 49px);
  overflow-y: auto;
}

.content-right {
  width: calc(100% - 13.3333vw - 16px);
  height: 100%;
}

.content-right-box1 {
  height: 211px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  margin-bottom: 16px;
}

.box1-bottom {
  padding: 16px;
}

.box1-main {
  height: 130px;
  padding: 16px;
  border-radius: 4px;
  background: #FAFAFA;
  box-sizing: border-box;
  border: 1px solid #ECF0F5;
  text-align: left;
}

.p-1 {
  display: flex;
  justify-content: space-between;
}

.content-right-box2 {
  height: calc(100% - 227px);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
}

.content-right-top >>> .el-input {
  width: 10.4167vw;
}

.table {
  height: calc(100% - 99px);
}

.table >>> .el-table th.el-table__cell>.cell {
  font-size: 14px;
  color: #999;
}

.pagination {
  height: 50px;
  border-radius: 0px 0px 6px 6px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}

.pagination >>> .el-pagination {
  padding: 11px 0 !important;
}

.dialog >>> .el-input {
  width: 300px;
}

</style>